import { render } from "./AudioAttachment.vue?vue&type=template&id=651543b8&scoped=true"
import script from "./AudioAttachment.vue?vue&type=script&lang=js"
export * from "./AudioAttachment.vue?vue&type=script&lang=js"

import "./AudioAttachment.vue?vue&type=style&index=0&id=651543b8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-651543b8"]])

export default __exports__